<template>
  <b-card>
    <b-form @submit="saveChanges">
      <b-row>
        <b-col sm="12" lg="6">
          <b-form-group label="Copyright *" label-for="copyright">
            <b-form-input id="copyright" v-model="copyright" required />
          </b-form-group>
        </b-col>
        <b-col sm="12" lg="6">
          <b-form-group label="Phone *" label-for="phone">
            <b-form-input id="phone" v-model="phone" required />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="Contact Link *" label-for="contact_link">
            <b-form-input id="contact_link" v-model="contact_link" required />
          </b-form-group>
        </b-col>
        <b-col class="d-flex justify-content-end">
          <b-button type="button" class="mr-1" variant="light">
            Cancel
          </b-button>
          <b-button type="submit" :disabled="isLoading" variant="primary">
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCol,
  BRow,
  BFormGroup,
  BCard,
  BFormInput,
  BButton,
  BForm,
} from 'bootstrap-vue'

export default {
  components: {
    BCol,
    BRow,
    BFormGroup,
    BCard,
    BFormInput,
    BButton,
    BForm,
  },

  data() {
    return {
      isLoading: false,
      copyright: '',
      contact_link: '',
      phone: '',
    }
  },

  mounted() {
    this.fetchFooterSettings()
  },

  methods: {
    fetchFooterSettings() {
      this.$http.get('/settings/footer').then(res => {
        this.copyright = res.data.data.copyright
        this.contact_link = res.data.data.contact_link
        this.phone = res.data.data.phone
      })
    },
    saveChanges(event) {
      event.preventDefault()
      this.isLoading = true

      this.$http
        .post('/settings/footer', {
          copyright: this.copyright,
          phone: this.phone,
          contact_link: this.contact_link,
        })
        .then(() => {
          this.$notif(
            'Success',
            'Footer settings has been successfully updated.',
            'success'
          )

          this.fetchFooterSettings()
          this.$store.dispatch('app/fetchGlobalSettings')
        })
        .catch(err => {
          this.$notif('Error', `${err.message}`, 'error')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
